import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { UrlQueryDef } from '../_appCommon/base/UrlQueryDef';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';

@Injectable()
export class ProductDataService extends EntityDataServiceBase
{
  @Output() productListCategoryIdChanged = new EventEmitter<number>();
  public productListCategoryId: number = -1;
  public getStock_WebApiMethod: string = "getStock";
  public getProductById_WebApiMethod: string = "getProductById";
  public getCustomerProductList_WebApiMethod: string = "GetCustomerProductList";
  public getStockFilteredByCategoryId_WebApiMethod: string = "getStockFilteredByCategoryId";

  constructor(protected http: HttpClient)
  {
    super(http, 'product');
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();
    this.entityConfig.entityName = 'product';
    this.entityConfig.apiUrl = 'api/Product';
  }

  // sets the current "category-id" and emits the change
  public setProductListCategoryId(id: number)
  {
    this.productListCategoryId = id;
    this.productListCategoryIdChanged.emit(this.productListCategoryId);
  }

  // gets all the products filtered by "category-id"
  public getStockFilteredByCategoryId(queryDef: UrlQueryDef): Observable<any>
  {
    let observable: Observable<any> = this.http.get(this.createUrl(this.getStockFilteredByCategoryId_WebApiMethod),
      queryDef.getRequestConfig()).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  // gets all the products (not filtered)
  public getProductStock(queryDef: UrlQueryDef): Observable<any>
  {
    let observable = this.http.get(this.createUrl(this.getStock_WebApiMethod),
      queryDef.getRequestConfig()).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  // gets one product by its "id"
  public getProductById(queryDef: UrlQueryDef): Observable<any>
  {
    let observable = this.http.get(this.createUrl(this.getProductById_WebApiMethod),
      queryDef.getRequestConfig()).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

}

